import React from "react"
import { useSiteTranslations } from "@hooks/useSiteTranslations"
import { BlogPostCard } from "../blog-post-card/BlogPostCard"
import { AnimateWrapper } from "../animate-wrapper/AnimateWrapper"

import * as s from "./BlogPostsSummary.module.scss"

export const BlogPostsSummary = ({ posts }) => {
  const {
    generalTranslations: { general },
  } = useSiteTranslations()

  return (
    <AnimateWrapper>
      <div className={s.Wrapper}>
        <div className={s.BlogPostsSummary}>
          <h4 className={s.BlogPostsSummary__subTitle}>
            {general.homepage.latestNewsSubtitleText}
          </h4>
          <h3 className={s.BlogPostsSummary__title}>
            {general.homepage.latestNewsTitleText}
          </h3>

          <div className={s.PostsContainer}>
            {posts.map((post, idx) => {
              return <BlogPostCard key={idx} post={post} />
            })}
          </div>
        </div>
      </div>
    </AnimateWrapper>
  )
}
